export default "__VITE_ASSET__ByOZ5573__"